import { render, staticRenderFns } from "./TranslationSidebar.vue?vue&type=template&id=587fc9fc&scoped=true"
import script from "./TranslationSidebar.vue?vue&type=script&lang=js"
export * from "./TranslationSidebar.vue?vue&type=script&lang=js"
import style0 from "./TranslationSidebar.vue?vue&type=style&index=0&id=587fc9fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587fc9fc",
  null
  
)

export default component.exports